import React from "react"
import propTypes from "prop-types"
import { Link } from "react-router-dom"
import "./styles.scss"

import logoBlack from "./images/logo-black.svg"
import logoWhite from "./images/logo-white.svg"
import logoMobileBlack from "./images/logo-mobile-black.svg"
import logoMobileWhite from "./images/logo-mobile-white.svg"

const Logo = ({ href, title, color, mobile }) => {
  return (
    <Link to={href} className="logo">
      {mobile ? (
        <img
          className="logo--mobile"
          src={color === "black" ? logoMobileBlack : logoMobileWhite}
          title={title}
          alt={title}
        />
      ) : (
        <img
          className="logo--desktop"
          src={color === "black" ? logoBlack : logoWhite}
          title={title}
          alt={title}
        />
      )}
    </Link>
  )
}

Logo.propTypes = {
  href: propTypes.string.isRequired,
  title: propTypes.string.isRequired,
  color: propTypes.string.isRequired,
  mobile: propTypes.bool
}

Logo.defaultProps = {
  mobile: false
}

export default Logo
